import React from 'react';
import PropTypes from 'prop-types';
import MenuItemRender from './MenuItemRender';
import MenuEntitiesItem from './MenuEntitiesItem';

const MenuItem = ({ entities, parent, ...props }) => {
  const hasEntities = entities && entities.length;

  if (!hasEntities) return <MenuItemRender parent={parent} {...props} />;

  return <MenuEntitiesItem entities={entities} parent={parent} {...props} />;
};

MenuItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  eventType: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  parent: PropTypes.object,
  text: PropTypes.string,
  url: PropTypes.string,
  entities: PropTypes.array
};

MenuItem.defaultProps = {
  children: null,
  modifier: '',
  parent: {},
  text: '',
  url: '',
  entities: []
};

export default MenuItem;
